import BaseController from './basePlayerController';

export default class ControllerSpin extends BaseController {
  constructor({ container, ...props }) {
    super({ ...props });
    this._eButtonsTypes = {
      EBT_SPIN: 'spin_button',
    };
    this._eEventTypes =  {
      SPIN_CLICK: this.getEventName(this._eButtonsTypes.EBT_SPIN),
    };
    this._eElementsTypes = {
      EET_SPIN_ARROW: 'spin_button_arrow',
      EET_SPIN_BUTTON: this._eButtonsTypes.EBT_SPIN,
    };

    this.init(container);
    this.hideFreespins();
  }

  showFreespins(count, text) {
    if (count) this.freespinsCount = count;
    if (text) this.freespinsText = text;
    this.interactiveElements[this._eElementsTypes.EET_SPIN_BUTTON].classList.add('freespins_count_shown');
  }

  hideFreespins() {
    this.interactiveElements[this._eElementsTypes.EET_SPIN_BUTTON].classList.remove('freespins_count_shown');
  }

  runSpinAnimation() {
    const svg = this.interactiveElements[this._eElementsTypes.EET_SPIN_ARROW];
    svg.animate([
      {transform: 'rotate(0)'},
      {transform: `rotate(180deg)`},
    ], {
      duration: 200,
      easing: 'ease-out',
      iterations: 1,
    });
  }

  set freespinsCount(count) {
    const button = this.interactiveElements[this._eElementsTypes.EET_SPIN_BUTTON];

    button.setAttribute('data-freespins', count);

    if (!button.classList.contains('freespins_count_shown')) {
      button.classList.add('freespins_count_shown');
    }
  }

  set freespinsText(text) {
    // this.set(this._eElementsTypes.EET_FREESPINS_LABEL_TEXT, text);
  }

  _getMarkup() {
    return `<div class="spin_container">
        <!--    spin    -->
          <button id=${this.interactiveElementsIds[this._eElementsTypes.EET_SPIN_BUTTON]} class="spin_container__spin" data-color="spin" data-freespins="0">
            <svg id=${this.interactiveElementsIds[this._eElementsTypes.EET_SPIN_ARROW]} width="201" height="200" viewBox="0 0 201 200" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M99.628 48.9524C107.388 48.5461 114.741 50.0087 121.404 52.8119C139.077 60.2467 151.61 77.5741 151.915 97.8674H133.47C132.455 97.8674 131.906 99.1471 132.536 100.021L160.467 138.027C160.934 138.657 161.869 138.657 162.336 138.027L190.287 100C190.917 99.1268 190.369 97.8471 189.353 97.8471L170.868 97.8471C170.522 66.9908 149.721 40.9895 121.424 32.7218C112.913 30.2233 103.711 29.3498 94.184 30.4264C77.9941 32.2749 63.4699 39.9331 52.6834 51.1665L64.1606 66.7877C72.8344 56.4887 85.5101 49.6633 99.628 48.9524Z" fill="white"/>
              <path d="M30.1324 102.153C30.4777 133.009 51.2788 159.011 79.5755 167.278C88.0869 169.777 97.289 170.65 106.816 169.574C123.006 167.725 137.53 160.067 148.317 148.833L136.839 133.212C128.186 143.491 115.49 150.337 101.372 151.048C93.6122 151.454 86.2587 149.991 79.5959 147.188C61.9231 139.753 49.3896 122.426 49.0849 102.133H67.5296C68.5453 102.133 69.0937 100.853 68.464 99.9794L40.5329 61.9727C40.0657 61.343 39.1313 61.343 38.6641 61.9727L10.7126 99.9997C10.0829 100.873 10.6517 102.133 11.647 102.153L30.1324 102.153Z" fill="white"/>
            </svg>
          </button>
      </div>`
  }
}
